import type { ClimateScenario, TimeHorizon } from "./scoring/types";

/**
 * Canonical, ordered list of horizons Tab 2's comparison view can show — the
 * single source both server (row-picking) and client (filter UI, column
 * ordering) iterate over, so the two sides can't drift apart.
 */
export const HORIZONS: readonly TimeHorizon[] = ["historical", "2030", "2050"];

/** The two global emissions-scenario slots shown in the Scenario filter. */
export const SCENARIOS: readonly ClimateScenario[] = ["SSP2-4.5", "SSP5-8.5"];
